import { Component } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { ListaFuncionalidadeComponent } from '../../../shared/components/lista-funcionalidade/lista-funcionalidade.component';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';

@Component({
  selector: 'app-financas-home',
  imports: [
    ListaFuncionalidadeComponent,
    HeaderComponent
  ],
  templateUrl: './financas-home.component.html',
  styleUrl: './financas-home.component.css',
})
export class FinancasHomeComponent {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor() {
    this.moduloEnum = ModuloEnum.Financas;
    this.funcionalidadeEnum = FuncionalidadeEnum.Financas_Contas_Pagar;
  }
}
